import styled from 'styled-components/native';

const Container = styled.View`
	flex: 1;
	width: 75%;
	align-self: center;
`;

export default Container;
